import * as React from 'react';
import { useCurrentOrganisation } from '../../../../../../app/CurrentOrganisationProvider';
import { WizardStep } from '../../../../../../components/Wizard/WizardStep';
import { type OnSubmit, useWizard } from '../../../../../../design-system';
import {
  getLocationFields,
  type LocationFields,
  locationValidationSchema,
} from '../../../../../../utils/locations/FieldDefinitions';

const initialValues: LocationFields = {
  name: '',
  address: {
    address1: '',
    address2: '',
    address3: '',
    city: '',
    postCode: '',
    state: '',
    country: '',
  },
  coordinates: {
    latitude: '',
    longitude: '',
  },
  timeZone: '',
  installationPoint: null,
};

export const DetailsStep: React.FC = () => {
  const { state, setState, prevStep, nextStep, step } = useWizard();
  const { organisation } = useCurrentOrganisation();

  const onSubmit = React.useCallback<OnSubmit<LocationFields>>(
    ({ name, address, coordinates, timeZone, installationPoint }, { setSubmitting }) => {
      setSubmitting(true);
      setState({ name, address, coordinates, timeZone, installationPoint });
      nextStep();
    },
    [setState, nextStep],
  );

  return (
    <WizardStep<LocationFields>
      fields={Object.values(getLocationFields({ organisationId: organisation?.id }))}
      initialValues={{ ...initialValues, ...state }}
      name="Location details"
      onCancel={prevStep}
      onSubmit={onSubmit}
      step={step}
      subtitle=""
      validationSchema={locationValidationSchema}
    />
  );
};
